
import {
    IOptionPickerColorItem,
    OPTION_PICKER_TYPE_COLOR,
} from '@vfde-brix/option-picker';
import mountOptionPicker from './mountOptionPicker';
import { COLOR_KEY } from '../container/Options/constants';

/**
 * Mount the color picker
 *
 * @param container
 * @param colors
 * @param currentColor
 * @param onChangeAction
 */
export const mountColorOptionPicker = (container, { colors, currentColor }, onChangeAction?: (value: string) => void) => {
    const items: IOptionPickerColorItem[] = [];

    for (const [index, color] of colors.entries()) {
        let state;

        if (currentColor === color[COLOR_KEY] || index === 0) {
            state = 'checked';
        }

        items.push({
            stdValue: color[COLOR_KEY],
            stdColorName: color[COLOR_KEY],
            stdColorRgbValue: color.rgb,
            optState: state,
        });
    }

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        onChangeAction(target.value);
    };

    return mountOptionPicker(container, 'color-picker', OPTION_PICKER_TYPE_COLOR, items, onChange);
};
